export default {
  SET_LIST_USER_SETTING(state, listUserSetting) {
    let result = [];
    result = listUserSetting
    state.listUserSetting = result
  },
  REFRESH_USER_SETTING(state, data) {
    state.listUserSetting = JSON.parse(JSON.stringify(data));
  }
}